module.exports = __webpack_public_path__ + "static/media/Паспорт GALAD Тандем LED.f9ab381d.pdf";